var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47405 11.8401C6.35296 11.8401 6.96066 12.1565 7.23186 12.3423C7.32729 12.3925 7.5784 12.5482 7.64369 12.5633V4.2162C7.26702 3.5633 6.23744 3.05103 5.18778 3.05103C3.7966 3.05103 2.66155 3.83451 2.36523 4.42714V12.0159C2.37026 12.4629 2.62137 12.6437 2.93276 12.6437C3.16378 12.6437 3.30943 12.5633 3.46512 12.4428C3.78655 12.1816 4.52483 11.8401 5.47405 11.8401ZM10.5265 11.8401C11.4757 11.8401 12.209 12.1816 12.5304 12.4428C12.6861 12.5633 12.8318 12.6437 13.0578 12.6437C13.3691 12.6437 13.6303 12.4629 13.6303 12.0159V4.42714C13.334 3.83451 12.1989 3.05103 10.8128 3.05103C9.76311 3.05103 8.72852 3.5633 8.35686 4.2162V12.5733C8.41713 12.5583 8.66825 12.3976 8.76869 12.3423C9.0399 12.1565 9.6476 11.8401 10.5265 11.8401Z",
    fill: "#074B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlue);
export default __webpack_public_path__ + "static/media/book_blue.cce00352b24faabceb1d29acb7006766.svg";
export { ForwardRef as ReactComponent };